export default class HamburgerIcon {
  constructor() {
    this.hamburgerIcon = document.querySelector("#hamburger-icon")
    this.mainMenu = document.querySelector("#main-menu")

    this.hamburgerIcon.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    event.preventDefault()

    this.mainMenu.classList.toggle("opened")
  }
}
